import { Routes } from '@angular/router';
import { authGuard, roleGuard } from '../../guards/auth.guard';
import { UserRoles } from '@shared/models/user-roles';

export const avvRoutes: Routes = [
  {
    path: 'avv',
    title: 'AVV-Verzeichnis',
    loadComponent: () => import('./avv-list/avv-list').then(m => m.AVVListComponent),
    canActivate: [authGuard],
  },
  {
    path: 'avv/new',
    title: 'Neuer AVV-Eintrag',
    loadComponent: () => import('./avv-form/avv-form').then(m => m.AVVFormComponent),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.MASTERDATA_WRITE] },
  },
  {
    path: 'avv/:id/edit',
    title: 'AVV-Eintrag bearbeiten',
    loadComponent: () => import('./avv-form/avv-form').then(m => m.AVVFormComponent),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.MASTERDATA_WRITE] },
  },
];
